import { Pipe, PipeTransform } from '@angular/core';
import { merge } from 'lodash';

@Pipe({ name: 'inReviewTableColumnOptions' })
export class InReviewTableColumnOptionsPipe implements PipeTransform {
	/**
	 * Add the base datapoint to the column datapoint
	 * 
	 * @param options Original options
	 * @param index Index of the row
	 * @param base Base datapoint
	 */
	transform(options: any, index: number, base: string): Record<string, any> {
		if ('isFullPath' in options) {
			return options;
		}
		
		const path = `${base}[${index}].${options.path}`;
		const nOptions = Object.assign({}, options);
		Object.assign(nOptions, { path });

		return nOptions;
	}
}

@Pipe({ name: 'inReviewNestedTableOptions' })
export class InReviewNestedTableOptionsPipe implements PipeTransform {
	/**
	 * Add the base datapoint to nested table
	 * 
	 * @param options Original options
	 * @param index Index of the row
	 * @param base Base datapoint
	 */
	transform(options: any, index: number, base: string): Promise<Record<string, any>> {
		const path = `${base}[${index}].${options.options.path}`;
		const nOptions = merge({}, options);
		Object.assign(nOptions.options, { path });

		return nOptions;
	}
}

@Pipe({ name: 'inOnlyRealColumns' })
export class InOnlyRealColumnsPipe implements PipeTransform {
	
	/**
	 * Return only field columns.
	 * 
	 * @param columns Columns array
	 */
	transform(columns: Array<any>): Array<any> {
		return columns.filter(column => {
			return column.type !== 'table';
		});
	}
}